import { render, staticRenderFns } from "./LifeInsuranceChart.vue?vue&type=template&id=ed95265a&scoped=true"
import script from "./LifeInsuranceChart.vue?vue&type=script&lang=ts"
export * from "./LifeInsuranceChart.vue?vue&type=script&lang=ts"
import style0 from "./LifeInsuranceChart.vue?vue&type=style&index=0&id=ed95265a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed95265a",
  null
  
)

export default component.exports